import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	showMe: {
		id: 'cmp-currency-field-changeboarding-flag.show-me',
		defaultMessage: 'Show me',
		description:
			'Label for a button that showcases a new feature to the user by navigating them to a new view',
	},
	dismiss: {
		id: 'cmp-currency-formatting-changeboarding-flag.dismiss',
		defaultMessage: 'Dismiss',
		description: 'Label for a button that dismisses a flag message',
	},
	heading: {
		id: 'cmp-currency-formatting-changeboarding-flag.heading',
		defaultMessage: 'Currency and percentage formats',
		description: 'Heading for an engagement flag that promotes a new currency formatting feature',
	},
	body: {
		id: 'cmp-currency-formatting-changeboarding-flag.body',
		defaultMessage:
			"You can now format a number field to show a currency ($) or percentage (%) to help track your team's budgets and spending.",
		description:
			'Body of an engagement flag for a new feature. This describes how a user can interact with it.',
	},
});
